// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RefundSection_container__WhnBE {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
}

.RefundSection_SelectBox__IYLq7 {
    margin-bottom: 20px;
    align-items: center;
    padding: 16px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 0.2fr));
    gap: 16px;
}

.RefundSection_date__YJ\\+iC {
    padding: 8px;
    border-radius: 5px;
    margin-right: 1%;
    background: white;
    border: 1px solid rgba(203, 213, 225, 1);
}

.RefundSection_add__RAHqi {
    width: 15px;
    margin-left: auto;
    margin-bottom: 20px;
    background: rgba(29, 135, 82, 1);
    color: white;
    padding: 5px 20px;
    border-radius: 5px;
    font-size: 25px;
}


.RefundSection_filters__select__oOjyT {
  min-width: 160px;
}

/* Таблица */
.RefundSection_table__OScFV {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  font-size: 14px;
}

/* Заголовки таблицы */
.RefundSection_table__OScFV thead tr {
  background: #f9f9f9;
}

.RefundSection_table__OScFV th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #ddd;
}

/* Строки */
.RefundSection_table__OScFV td {
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
}

/* Зебра */
.RefundSection_table__OScFV tbody tr:nth-child(even) {
  background: #fafafa;
}

/* Hover */
.RefundSection_table__OScFV tbody tr:hover {
  background: #f0f7ff;
  transition: 0.2s;
}

/* Пустая строка */
.RefundSection_empty__yvKVh {
  text-align: center;
  color: #999;
  padding: 20px;
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/pages/tablesStyle/RefundSection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,6DAA6D;IAC7D,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;AACjB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 20px;\n}\n\n.SelectBox {\n    margin-bottom: 20px;\n    align-items: center;\n    padding: 16px;\n    background-color: rgba(255, 255, 255, 1);\n    border-radius: 8px;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 0.2fr));\n    gap: 16px;\n}\n\n.date {\n    padding: 8px;\n    border-radius: 5px;\n    margin-right: 1%;\n    background: white;\n    border: 1px solid rgba(203, 213, 225, 1);\n}\n\n.add {\n    width: 15px;\n    margin-left: auto;\n    margin-bottom: 20px;\n    background: rgba(29, 135, 82, 1);\n    color: white;\n    padding: 5px 20px;\n    border-radius: 5px;\n    font-size: 25px;\n}\n\n\n.filters__select {\n  min-width: 160px;\n}\n\n/* Таблица */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  background: white;\n  border-radius: 10px;\n  overflow: hidden;\n  font-size: 14px;\n}\n\n/* Заголовки таблицы */\n.table thead tr {\n  background: #f9f9f9;\n}\n\n.table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 1px solid #ddd;\n}\n\n/* Строки */\n.table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #eee;\n}\n\n/* Зебра */\n.table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n/* Hover */\n.table tbody tr:hover {\n  background: #f0f7ff;\n  transition: 0.2s;\n}\n\n/* Пустая строка */\n.empty {\n  text-align: center;\n  color: #999;\n  padding: 20px;\n  font-size: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RefundSection_container__WhnBE`,
	"SelectBox": `RefundSection_SelectBox__IYLq7`,
	"date": `RefundSection_date__YJ+iC`,
	"add": `RefundSection_add__RAHqi`,
	"filters__select": `RefundSection_filters__select__oOjyT`,
	"table": `RefundSection_table__OScFV`,
	"empty": `RefundSection_empty__yvKVh`
};
export default ___CSS_LOADER_EXPORT___;
